import loadable from '@loadable/component';

const FooterLoadable = loadable(() => import(/* webpackChunkName: "footer-component" */ './index'));

export default FooterLoadable;
